import i18n from '@/i18n'
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import { bluestoneH5Root } from '@/config'
Vue.use(Router)
const createRouter = () =>
  new Router({
    mode: 'history',
    routes: [
      {
        path: '*',
        redirect: '/'
      },
      {
        path: '/',
        name: 'PageView',
        component: resolve => require(['@/view/PageView'], resolve),
        children: [
          {
            path: '/',
            redirect: '/home'
          },
          {
            path: '/home',
            name: 'home',
            component: resolve => require(['@/view/crystal/HomePage'], resolve),
            meta: {
              title: i18n.t('router.index.087479-0')
            }
          },
          {
            path: '/download',
            name: 'download',
            component: resolve => require(['@/view/crystal/Download'], resolve),
            meta: {
              title: i18n.t('router.index.087479-1')
            }
          },
          {
            path: '/help',
            name: 'help',
            component: resolve => require(['@/view/PageView'], resolve),
            children: [
              {
                path: '',
                name: '',
                component: resolve => require(['@/view/crystal/Help'], resolve),
                meta: {
                  title: i18n.t('router.index.087479-2')
                }
              },
              {
                path: 'list',
                name: 'list',
                component: resolve => require(['@/view/crystal/HelpList'], resolve),
                meta: {
                  title: i18n.t('router.index.087479-3')
                }
              },
              {
                path: 'margin-ratio-page',
                name: 'MarginRatioPage',
                component: resolve => require(['@/view/crystal/MarginRatioPage'], resolve),
                meta: {
                  title: i18n.t('router.index.087479-4'),
                  hideFooter: true,
                  hideHeader: true
                }
              }
            ]
          },
          {
            path: '/about',
            name: 'about',
            component: resolve => require(['@/view/crystal/About'], resolve),
            meta: {
              title: i18n.t('router.index.087479-1')
            }
          },
          // {
          //   path: '/partner',
          //   name: 'partner',
          //   component: resolve => require(['@/view/crystal/Partner'], resolve),
          //   meta: {
          //     title: '理财师招募'
          //   }
          // },
          {
            path: '/userCenter',
            name: 'userCenter',
            component: resolve => require(['@/view/crystal/UserCenter'], resolve),
            meta: {
              title: i18n.t('router.index.087479-5'),
              hideFooter: true
            }
          },
          {
            path: '/userCenter/deposit',
            name: 'deposit',
            component: resolve => require(['@/view/crystal/UserCenter'], resolve),
            meta: {
              title: i18n.t('router.index.087479-6'),
              hideFooter: true
            }
          }
        ]
      },
      // 针对以前的帮助链接重定向
      {
        path: '/m/help',
        redirect: '/help'
      },
      // 这里是因为安卓的老版本多配了/
      {
        path: '//m/help',
        redirect: '/help'
      },
      {
        path: '/m/help/list',
        redirect: '/help/list'
      },
      {
        path: '/m/help/category',
        redirect: '/help/list'
      },
      {
        path: '/m/help/info',
        redirect: '/help/list'
      },
      // 处理老的app跳官网的问题
      {
        path: '/account/auth',
        redirect: '/userCenter'
      }
    ]
  })
const router = createRouter()
// 路由守卫
router.beforeEach((to, from, next) => {
  // H5 设置头尾是否展示
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', location.href])
    }
  }
  // 用户中心路由拦截,处理老app的转股和用户中心问题
  if (to.path == '/userCenter' && to.query.redirect_to) {
    let uri = to.query.redirect_to.split('_')[2]
    uri = uri == 'transfer' ? 'transferStock' : uri
     // 禁掉后退
    window.history.pushState(null, null)
    location.replace(bluestoneH5Root + '/userCenter/' + uri + '?_appAdd=110&share=0')
  }
  window.scrollTo(0, 0)
  next()
})
router.afterEach((to, from) => {
  if (store.state.webType == 'h5') {
    store.commit('setHideHeader', to.meta.hideHeader || false)
    store.commit('setHideFooter', to.meta.hideFooter || false)
  } else {
    store.commit('setHideHeader', false)
    store.commit('setHideFooter', false)
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js